import * as React from "react"
const SvgFlag = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7 14.714v6a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713v-15a.97.97 0 0 1 .287-.712A.97.97 0 0 1 6 4.714h7.175a.96.96 0 0 1 .625.225q.275.225.35.575l.25 1.2H19q.424 0 .712.288a.97.97 0 0 1 .288.712v8a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287h-5.175a.96.96 0 0 1-.625-.225 1 1 0 0 1-.35-.575l-.25-1.2zm7.65 0H18v-6h-4.425a.96.96 0 0 1-.625-.225 1 1 0 0 1-.35-.575l-.25-1.2H7v6h6.425a.96.96 0 0 1 .625.225q.275.225.35.575z" />
  </svg>
)
export default SvgFlag
